// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mt-rating__verified{align-items:center;color:#9e9e9e;display:flex;font-size:10px;font-weight:400;gap:3px}.mt-rating__verified svg{color:var(--success);width:15px}", ""]);
// Exports
module.exports = exports;
